import {
  FETCH_AUTOPROCINTEGRATION_JOB_TYPES_FULFILLED,
  FETCH_DATACOLLECTIONGROUP_JOB_TYPES_FULFILLED,
  FETCH_DATACOLLECTIONS_JOB_TYPES_FULFILLED,
  FETCH_DATACOLLECTION_JOB_TYPES_FULFILLED,
  FETCH_JOBS_FULFILLED,
  FETCH_JOBS_PENDING,
  LOG_OUT,
} from '../constants/ActionTypes'

const initialState = {
  data: [],
  type: null,
  fetched: false,
  fetching: false,
  datacollectionJobTypes: {},
  datacollectionsJobTypes: {},
  datacollectionGroupJobTypes: {},
}

const jobs = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATACOLLECTION_JOB_TYPES_FULFILLED: {
      state = { ...state, datacollectionJobTypes: action.payload.data }
      break
    }

    case FETCH_DATACOLLECTIONS_JOB_TYPES_FULFILLED: {
      state = { ...state, datacollectionsJobTypes: action.payload.data }
      break
    }

    case FETCH_AUTOPROCINTEGRATION_JOB_TYPES_FULFILLED: {
      state = { ...state, autoprocintegrationJobTypes: action.payload.data }
      break
    }
    case FETCH_JOBS_PENDING: {
      state = { ...state, fetching: true }
      break
    }
    case FETCH_JOBS_FULFILLED: {
      state = { ...state, data: action.payload.data, fetching: false }
      break
    }
    case FETCH_DATACOLLECTIONGROUP_JOB_TYPES_FULFILLED: {
      state = { ...state, datacollectionGroupJobTypes: action.payload.data }
      break
    }
    case LOG_OUT: {
      state = {
        data: [],
        type: null,
        fetched: false,
        fetching: false,
        datacollectionJobTypes: {},
        datacollectionGroupJobTypes: {},
      }
      break
    }
    default:
      break
  }
  return state
}

export default jobs
